import { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [mobileCatOpen, setMobileCatOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    function handleScroll() {
      setScrolled(window.scrollY > 20);
    }
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    if (mobileOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [mobileOpen]);

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      scrolled
        ? "bg-background-50 border-b border-background-200"
        : "bg-background-50"
    }`}>
      <div className="w-full px-4 md:px-8">
        <div className="flex items-center justify-between h-16 md:h-18">
          <Link to="/" className="flex items-center gap-2 group flex-shrink-0">
            <span className="w-9 h-9 rounded-full bg-primary-500 flex items-center justify-center">
              <i className="ri-file-list-3-line text-background-50 text-sm"></i>
            </span>
            <span className="text-foreground-900 font-semibold text-sm tracking-tight whitespace-nowrap">cssbuy.biz</span>
          </Link>

          <div className="hidden md:flex items-center gap-6">
            <Link to="/" className="text-foreground-700 hover:text-foreground-900 text-sm font-medium transition-colors whitespace-nowrap cursor-pointer">Início</Link>
            <a href="#categorias" className="text-foreground-700 hover:text-foreground-900 text-sm font-medium transition-colors whitespace-nowrap cursor-pointer">Categorias</a>
            <a href="#comparacao" className="text-foreground-700 hover:text-foreground-900 text-sm font-medium transition-colors whitespace-nowrap cursor-pointer">Comparação</a>
            <a href="#faq" className="text-foreground-700 hover:text-foreground-900 text-sm font-medium transition-colors whitespace-nowrap cursor-pointer">FAQ</a>
            <Link to="/guia-de-compras" className="text-foreground-700 hover:text-foreground-900 text-sm font-medium transition-colors whitespace-nowrap cursor-pointer">Guia de Compras</Link>
            <Link to="/cssbuy-spreadsheet-guia-completo" className="text-foreground-700 hover:text-foreground-900 text-sm font-medium transition-colors whitespace-nowrap cursor-pointer">Blog</Link>
          </div>

          <div className="hidden md:flex items-center gap-3 flex-shrink-0">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="px-5 py-2.5 rounded-full bg-foreground-900 text-background-50 text-sm font-medium hover:bg-foreground-800 transition-all whitespace-nowrap cursor-pointer"
            >
              cssbuy sheet
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="px-5 py-2.5 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
            >
              buy it now
            </a>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer flex-shrink-0 rounded-lg hover:bg-background-100 transition-colors"
            aria-label="Menu"
          >
            <i className={`text-xl text-foreground-900 ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden fixed top-16 left-0 right-0 bottom-0 bg-background-50 z-40 flex flex-col overflow-y-auto">
          <div className="flex-1 px-5 py-4 flex flex-col gap-0.5">
            <Link
              to="/"
              onClick={() => setMobileOpen(false)}
              className="flex items-center gap-3 text-foreground-900 text-base font-semibold py-3.5 px-4 rounded-xl hover:bg-background-100 transition-colors cursor-pointer"
            >
              <span className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center flex-shrink-0">
                <i className="ri-home-4-line text-background-50 text-sm"></i>
              </span>
              Início
            </Link>

            <a
              href="#categorias"
              onClick={() => setMobileOpen(false)}
              className="flex items-center gap-3 text-foreground-900 text-base font-medium py-3.5 px-4 rounded-xl hover:bg-background-100 transition-colors cursor-pointer"
            >
              <span className="w-8 h-8 rounded-lg bg-accent-100 flex items-center justify-center flex-shrink-0">
                <i className="ri-grid-line text-accent-600 text-sm"></i>
              </span>
              Categorias
            </a>

            <div>
              <button
                onClick={() => setMobileCatOpen(!mobileCatOpen)}
                className="w-full flex items-center justify-between text-foreground-900 text-base font-medium py-3.5 px-4 rounded-xl hover:bg-background-100 transition-colors cursor-pointer"
              >
                <span className="flex items-center gap-3">
                  <span className="w-8 h-8 rounded-lg bg-secondary-100 flex items-center justify-center flex-shrink-0">
                    <i className="ri-list-check-3 text-secondary-600 text-sm"></i>
                  </span>
                  Todas as Categorias
                </span>
                <i className={`text-foreground-400 text-lg transition-transform duration-200 ${mobileCatOpen ? 'rotate-180' : ''}`}>
                  ri-arrow-down-s-line
                </i>
              </button>

              {mobileCatOpen && (
                <div className="mx-4 mt-1 mb-2 bg-background-100 rounded-2xl p-2.5 grid grid-cols-1 gap-0.5">
                  {categories.map((cat) => (
                    <a
                      key={cat.name}
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      onClick={() => setMobileOpen(false)}
                      className="flex items-center gap-3 px-4 py-3 text-sm text-foreground-800 font-medium hover:bg-background-50 rounded-xl transition-colors cursor-pointer"
                    >
                      <span className="w-2 h-2 rounded-full bg-primary-400 flex-shrink-0"></span>
                      {cat.name}
                    </a>
                  ))}
                </div>
              )}
            </div>

            <a
              href="#comparacao"
              onClick={() => setMobileOpen(false)}
              className="flex items-center gap-3 text-foreground-900 text-base font-medium py-3.5 px-4 rounded-xl hover:bg-background-100 transition-colors cursor-pointer"
            >
              <span className="w-8 h-8 rounded-lg bg-accent-100 flex items-center justify-center flex-shrink-0">
                <i className="ri-bar-chart-2-line text-accent-600 text-sm"></i>
              </span>
              Comparação
            </a>

            <a
              href="#faq"
              onClick={() => setMobileOpen(false)}
              className="flex items-center gap-3 text-foreground-900 text-base font-medium py-3.5 px-4 rounded-xl hover:bg-background-100 transition-colors cursor-pointer"
            >
              <span className="w-8 h-8 rounded-lg bg-accent-100 flex items-center justify-center flex-shrink-0">
                <i className="ri-question-line text-accent-600 text-sm"></i>
              </span>
              FAQ
            </a>

            <Link
              to="/guia-de-compras"
              onClick={() => setMobileOpen(false)}
              className="flex items-center gap-3 text-foreground-900 text-base font-medium py-3.5 px-4 rounded-xl hover:bg-background-100 transition-colors cursor-pointer"
            >
              <span className="w-8 h-8 rounded-lg bg-primary-100 flex items-center justify-center flex-shrink-0">
                <i className="ri-book-open-line text-primary-600 text-sm"></i>
              </span>
              Guia de Compras
            </Link>

            <Link
              to="/cssbuy-spreadsheet-guia-completo"
              onClick={() => setMobileOpen(false)}
              className="flex items-center gap-3 text-foreground-900 text-base font-medium py-3.5 px-4 rounded-xl hover:bg-background-100 transition-colors cursor-pointer"
            >
              <span className="w-8 h-8 rounded-lg bg-secondary-100 flex items-center justify-center flex-shrink-0">
                <i className="ri-article-line text-secondary-600 text-sm"></i>
              </span>
              Blog
            </Link>
          </div>

          <div className="px-5 py-5 border-t border-background-200 bg-background-50">
            <div className="flex flex-col gap-3">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                onClick={() => setMobileOpen(false)}
                className="w-full py-3.5 rounded-full bg-foreground-900 text-background-50 text-base font-semibold text-center cursor-pointer hover:bg-foreground-800 transition-colors"
              >
                cssbuy sheet
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                onClick={() => setMobileOpen(false)}
                className="w-full py-3.5 rounded-full bg-primary-500 text-background-50 text-base font-semibold text-center cursor-pointer hover:bg-primary-600 transition-colors"
              >
                buy it now
              </a>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}